module.exports = {
      id: "telegram-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "sprite.b16108e5f95a8323b5a812454e446fa5.svg#telegram-usage",
      toString: function () {
        return this.url;
      }
    }